import Marquee from "react-fast-marquee";

const ITEMS = [
  "Safe & Vault Specialists",
  "Safe Opening",
  "Heavy Safe Moving",
  "Safe Removal & Disposal",
  "Difficult Safe Work",
  "Norwalk, California",
];

export const EditorialMarquee = () => (
  <div className="border-y border-white/10 bg-ink py-6 md:py-9" data-testid="editorial-marquee">
    <Marquee speed={38} autoFill gradient={false}>
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="text-stroke px-8 font-heading text-3xl font-black uppercase tracking-tight md:text-5xl">
            {t}
          </span>
          <span className="h-1.5 w-1.5 rounded-full bg-gold" />
        </span>
      ))}
    </Marquee>
  </div>
);
